
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _, { isNull } from 'lodash';
import { connect } from 'react-redux';
import UserProfileMain from './index';
import { Waiting } from '../../components';
import { Switch, Route } from 'react-router-dom';
import HealthReport from '../../components/UserProfile/healthReportCard'

class UserProfile extends Component {
  constructor(props) {
    super(props);
  }

  renderProfile = () => {
    const { companyId, history} = this.props;
    return(<UserProfileMain companyId={companyId} history={history}/>)
  }

  renderHealthReport = () => {
    const { companyId, history} = this.props;
    return(<HealthReport companyId={companyId} history={history}/>)
  }

  render() {
    const { user, userId} = this.props;
    if (_.isUndefined(user) || _.isNull(user) || _,isNull(userId) ) {
      return <Waiting />
    }
    return (
      <Switch>
        <Route path="/profile" render={this.renderProfile} exact={true}/>
        <Route path="/profile/health-report" render={this.renderHealthReport} exact={true}/>
      </Switch>
    );
  }
}
    
UserProfile.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.number,
  companyId: PropTypes.number,
  history: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  userId: state.profileData.userId
})
 
export default connect(mapStateToProps, null)(((UserProfile)));